import api from '../index'

export interface captchaResult {
  captcha_img: string
  sys_captcha: string
}
export interface loginRequest {
  username: string
  password: string
  sys_captcha: string
  captcha: string
}
export interface userGetEmailCodeRequest {
  username: string
  captcha: string
  sys_captcha: string
}
export interface resetPasswordRequest {
  username: string
  password: string
  password_confirmation: string
  email_code: string
}
export interface registerRequest {
  country: string
  username: string
  password: string
  password_confirmation: string
  email_code: string
}
export interface userSettingRequest {
  avatar: string
  name: string
}

export default {
  // 验证码
  captcha: () => api.get<captchaResult>('member-api/captcha'),

  // 登录
  login: (data: loginRequest) => api.post('member-api/login', data),

  // 请求用户信息
  currentUser: () => api.get('member-api/current-user'),

  // 获邮箱验证码(重置密码)
  resetPasswordEmailCode: (data: userGetEmailCodeRequest) => api.post('member-api/reset-password/email-code', data),

  // 重置密码
  resetPassword: (data: resetPasswordRequest) => api.post('member-api/reset-password', data),

  // 获邮邮箱验证码(注册)
  registerEmailCode: (data: userGetEmailCodeRequest) => api.post('member-api/register/email-code', data),

  // 用户注册
  register: (data: registerRequest) => api.post('member-api/register', data),

  // 修改用户基本信息
  userSetting: (data: userSettingRequest) => api.put('member-api/user_setting', data),
  // 修改密码
  passwordEdit: (data: {
    avatar: string
    name: string
    old_password: string
    password: string
    confirm_password: string
  }) => api.put('member-api/user_setting', data),

  // 获取权限
  permission: () => api.get('user/permission', {
    baseURL: '/mock/',
  }),

  // 获取偏好设置
  preferences: () => api.get('user/preferences', {
    baseURL: '/mock/',
  }),

  // 修改偏好设置
  preferencesEdit: (preferences: string) => api.post('user/preferences/edit', {
    preferences,
  }, {
    baseURL: '/mock/',
  }),

  // 获取标签栏固定标签页数据
  tabbar: () => api.get('user/tabbar', {
    baseURL: '/mock/',
  }),

  // 修改标签栏固定标签页数据
  tabbarEdit: (tabbar: string) => api.post('user/tabbar/edit', {
    tabbar,
  }, {
    baseURL: '/mock/',
  }),

  // 获取收藏夹
  favorites: () => api.get('user/favorites', {
    baseURL: '/mock/',
  }),

  // 修改收藏夹
  favoritesEdit: (favorites: string) => api.post('user/favorites/edit', {
    favorites,
  }, {
    baseURL: '/mock/',
  }),
}
